/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EditStoryMutationVariables = Types.Exact<{
  input: Types.InputMaybe<Types.FeedUpdate>;
}>;


export type EditStoryMutation = { __typename: 'Mutation', updateFeed: { __typename: 'Feed', argument_type: string, author_id: number | null, body: string | null, body_updated_at: string | null, campaign_id: number, created_at: string, id: string, properties: string | null, gallery: Array<string> | null } | null };


export const EditStoryDocument = gql`
    mutation editStory($input: FeedUpdate) {
  updateFeed(input: $input) {
    argument_type
    author_id
    body
    body_updated_at
    campaign_id
    created_at
    id
    properties
    gallery
    __typename
  }
}
    `;
export type EditStoryMutationFn = Apollo.MutationFunction<EditStoryMutation, EditStoryMutationVariables>;

/**
 * __useEditStoryMutation__
 *
 * To run a mutation, you first call `useEditStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStoryMutation, { data, loading, error }] = useEditStoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditStoryMutation(baseOptions?: Apollo.MutationHookOptions<EditStoryMutation, EditStoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditStoryMutation, EditStoryMutationVariables>(EditStoryDocument, options);
      }
export type EditStoryMutationHookResult = ReturnType<typeof useEditStoryMutation>;
export type EditStoryMutationOptions = Apollo.BaseMutationOptions<EditStoryMutation, EditStoryMutationVariables>;